<template>
  <div
    ref="container"
    class="tw-overflow-x-hidden"
    @mouseenter="onEnter"
    @mouseleave="onLeave"
  >
    <div class="mask" :style="maskStyle">
      <div ref="textRef" :class="textClasses" :style="textStyle">
        {{ text }}
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import gsap from 'gsap'

const props = defineProps({
  text: { type: String, Number },
  maxLength: { type: [String, Number], default: 100 },
  textClasses: { type: String, default: '' },
})

const container = ref(null)
const textRef = ref(null)
let animation = null
const isHovered = ref(false)

const onEnter = async () => {
  isHovered.value = true
  await nextTick()

  const maskWidth = container.value.querySelector('.mask').offsetWidth
  const textWidth = textRef.value.scrollWidth

  if (textWidth <= maskWidth) return

  let diff_px = textWidth - maskWidth
  let unit_duration = 0
  if (diff_px > 0) {
    unit_duration = (diff_px * 30) / 1000
  }
  animation = gsap.timeline({ repeat: -1 })

  // رفتن به چپ (آروم)
  animation.to(textRef.value, {
    x: textWidth - maskWidth,
    duration: unit_duration,
    ease: 'power1.inOut',
  })

  // برگشت به اول (سریع)
  animation.to(textRef.value, {
    x: 0,
    duration: 0.5,
    delay: 1,
    ease: 'power1.out',
  })

  // animation = gsap.to(textRef.value, {
  //   x: textWidth - maskWidth,
  //   duration: unit_duration,
  //   ease: "power1.inOut",
  //   repeat: -1,
  //   yoyo: true,
  // });
}

const onLeave = () => {
  isHovered.value = false
  if (animation) animation.kill()

  gsap.to(textRef.value, { x: 0, duration: 0.5, ease: 'power1.out' })
}

const maskStyle = computed(() => ({
  maxWidth:
    props.maxLength === 'full'
      ? '100%'
      : props.maxLength.toString().includes('%')
      ? props.maxLength
      : `${props.maxLength}ch`,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'flex',
}))

const textStyle = computed(() => ({
  display: 'inline-block',
  // cursor: "pointer",
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  overflow: isHovered.value ? 'visible' : 'hidden',
  textOverflow: isHovered.value ? 'clip' : 'ellipsis',
}))
</script>
